import { Input, Popover, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Styles } from './styles';

export function validChar(char) {
  /**
   * valida lower
   */
  const regLower = new RegExp('[a-z]');
  const testLower = regLower.test(char);

  /**
   * valida upper
   */
  const regUpper = new RegExp('[A-Z]');
  const testUpper = regUpper.test(char);

  /**
   * valida number
   */
  const regNumber = new RegExp('[0-9]');
  const testNumber = regNumber.test(char);

  /**
   * valida number
   */
  const regSpecial = new RegExp('\\W');
  const testSpecial = regSpecial.test(char);

  return {
    testLower,
    testUpper,
    testNumber,
    testSpecial,
  };
}

export function validObjTests(
  listContent,
  { testLower, testUpper, testNumber, testSpecial }
) {
  return listContent.map(cont => {
    let result = null;
    if (cont.id === 'M') {
      result = testUpper;
    } else if (cont.id === 'm') {
      result = testLower;
    } else if (cont.id === '9') {
      result = testNumber;
    } else if (cont.id === '#') {
      result = testSpecial;
    }
    return result;
  });
}

export function requiredContent(requirements) {
  const listContent = [];

  requirements.forEach(req => {
    if (req === 'M') {
      listContent.push({ id: req, desc: 'Possuir uma letra maisucula.' });
    } else if (req === 'm') {
      listContent.push({ id: req, desc: 'Possuir uma letra minuscula.' });
    } else if (req === '9') {
      listContent.push({ id: req, desc: 'Possuir um caracter numerico.' });
    } else if (req === '#') {
      listContent.push({ id: req, desc: 'Possuir um caracter especial.' });
    }
    return null;
  });

  return listContent;
}

function CheckPass(params) {
  const title = 'A senha deve atender aos seguintes requisitos:';

  const listContent = requiredContent(params.requisitos);
  const defaultContent = () => (
    <>
      <Styles />
      <Row>
        <ul>
          <li key={0}>
            <Typography.Text className="invalid">
              Possuir ao menos 8 caracteres.
            </Typography.Text>
          </li>
          {listContent.map(cont => (
            <li key={cont.id}>
              <Typography.Text className="invalid">{cont.desc}</Typography.Text>
            </li>
          ))}
        </ul>
      </Row>
    </>
  );
  const [content, setContent] = useState(defaultContent);

  const isValidPass = (tests, char) => {
    const isValid = !!(!tests.includes(false) && char.length >= 8);
    params.setIsValidPass(isValid);
  };

  const handleChangePass = char => {
    const newContent = tests => (
      <>
        <Styles />
        <Row>
          <ul>
            <li key={0}>
              <Typography.Text
                className={char.length >= 8 ? 'valid' : 'invalid'}
              >
                Possuir ao menos 8 caracteres.
              </Typography.Text>
            </li>
            {listContent.map(cont => (
              <li key={cont.id}>
                <Typography.Text
                  className={
                    (cont.id === 'm' && tests.testLower) ||
                    (cont.id === 'M' && tests.testUpper) ||
                    (cont.id === '9' && tests.testNumber) ||
                    (cont.id === '#' && tests.testSpecial)
                      ? 'valid'
                      : 'invalid'
                  }
                >
                  {cont.desc}
                </Typography.Text>
              </li>
            ))}
          </ul>
        </Row>
      </>
    );

    const objTests = validChar(char);

    const returnNewContent = newContent(objTests);

    const validParamsArray = validObjTests(listContent, { ...objTests });

    isValidPass(validParamsArray, char);
    params.setPass(char);
    return returnNewContent;
  };

  const StrongPass = () => (
    <Popover
      title={title}
      content={content}
      trigger="focus"
      placement="bottomLeft"
    >
      <params.formProps
        name={params.name}
        label={params.label}
        labelCol={params.labelCol}
        labelAlign={params.labelAlign}
        rules={[
          { required: params.required, message: 'Por favor, insira a senha!' },
        ]}
      >
        <Input.Password
          disabled={params.disabled}
          autoComplete="off"
          style={{ width: '100%' }}
          onChange={value => {
            const returnHandle = handleChangePass(value.currentTarget.value);
            setContent(returnHandle);
          }}
          placeholder="*****"
        />
      </params.formProps>
    </Popover>
  );
  return StrongPass();
}
/**
 * param = M:Maiusculo, m:Minusculo, 9:Numerico, #:Caracter Especial.
 */
CheckPass.propTypes = {
  requisitos: PropTypes.arrayOf(PropTypes.string).isRequired,
  setIsValidPass: PropTypes.func.isRequired,
  setPass: PropTypes.func,
  formProps: PropTypes.func,
  labelCol: PropTypes.objectOf(PropTypes.object),
  labelAlign: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
};

CheckPass.defaultProps = {
  setPass: () => {},
  formProps: () => {},
  labelCol: { span: 4 },
  labelAlign: 'left',
  required: false,
  disabled: false,
  label: 'Senha',
  name: 'strongPass',
};

export default CheckPass;
